export default __webpack_public_path__ + "static/media/profile-gold.8a569142.svg";